module.exports = __webpack_public_path__ + "img/0Q3B0162_L_BlackMatted.ce3d4f43.jpg";